module.exports = __webpack_public_path__ + "static/media/blogs_image.863466f6.png";